/*
 --------------------------------------------------
 --------------------------------------------------
     Table Name : LU_AppFeatures
 --------------------------------------------------
 --------------------------------------------------
 DO NOT MODIFY MANUALLY
 --------------------------------------------------
 -------------------------------------------------- */

// Types
export type Application_Integration_Module = 'Application_Integration_Module';
export type Courses_Module = 'Courses_Module';
export type Exam_System_Module = 'Exam_System_Module';
export type Laerdal_Integration_Module = 'Laerdal_Integration_Module';
export type Live_Monitors = 'Live_Monitors';
export type Monitor_Controls = 'Monitor_Controls';
export type Notifications_Module = 'Notifications_Module';
export type Participant_Driven_Learning = 'Participant_Driven_Learning';
export type Remote_Exams = 'Remote_Exams';
export type Reservation_Module = 'Reservation_Module';
export type Show_Hidden_Features = 'Show_Hidden_Features';
export type Simulators_Module = 'Simulators_Module';

export type AppFeature =
    | Application_Integration_Module
    | Courses_Module
    | Exam_System_Module
    | Laerdal_Integration_Module
    | Live_Monitors
    | Monitor_Controls
    | Notifications_Module
    | Participant_Driven_Learning
    | Remote_Exams
    | Reservation_Module
    | Show_Hidden_Features
    | Simulators_Module;

// Constants
export const APPLICATION_INTEGRATION_MODULE: AppFeature = 'Application_Integration_Module' as const;
export const COURSES_MODULE: AppFeature = 'Courses_Module' as const;
export const EXAM_SYSTEM_MODULE: AppFeature = 'Exam_System_Module' as const;
export const LAERDAL_INTEGRATION_MODULE: AppFeature = 'Laerdal_Integration_Module' as const;
export const LIVE_MONITORS: AppFeature = 'Live_Monitors' as const;
export const MONITOR_CONTROLS: AppFeature = 'Monitor_Controls' as const;
export const NOTIFICATIONS_MODULE: AppFeature = 'Notifications_Module' as const;
export const PARTICIPANT_DRIVEN_LEARNING: AppFeature = 'Participant_Driven_Learning' as const;
export const REMOTE_EXAMS: AppFeature = 'Remote_Exams' as const;
export const RESERVATION_MODULE: AppFeature = 'Reservation_Module' as const;
export const SHOW_HIDDEN_FEATURES: AppFeature = 'Show_Hidden_Features' as const;
export const SIMULATORS_MODULE: AppFeature = 'Simulators_Module' as const;

const LU_AppFeatures = {
    APPLICATION_INTEGRATION_MODULE,
    COURSES_MODULE,
    EXAM_SYSTEM_MODULE,
    LAERDAL_INTEGRATION_MODULE,
    LIVE_MONITORS,
    MONITOR_CONTROLS,
    NOTIFICATIONS_MODULE,
    PARTICIPANT_DRIVEN_LEARNING,
    REMOTE_EXAMS,
    RESERVATION_MODULE,
    SHOW_HIDDEN_FEATURES,
    SIMULATORS_MODULE,
} as const;

export default LU_AppFeatures;
